module.exports = {"page":{"EBON":{"ERROR":{"TEXT_1":"Malheureusement, <b>votre paiement a échoué</b> pour une de ces raisons :","TEXT_2":"<b>le paiement a été refusé par votre banque ;</b>","TEXT_3":"<b>le solde restant de votre carte est insuffisant ;</b>","TEXT_4":"<b>vous avez abandonné votre panier.</b>"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/services/i18n/json/191.json
// module id = 1058
// module chunks = 0